export const IconSuitcaseCompany: {
  name: 'icon_suitcase_company-e9f9be48eed9'
} = {
  name: 'icon_suitcase_company-e9f9be48eed9'
}
